import React from 'react';
import PropTypes from 'prop-types';

import Avatar from '../Avatar';

const AdminPanelOnlineUserListItem = ({
  user,
}) => {
  const client = user.client || user.external_client;

  return (
    <tr>
      <th scope="row">
        <Avatar user={user} />
        <a href={`${client.host}/admin/users/${user.uuid}/edit`} target="_blank" rel="noreferrer">
          {user.name}
          <i className="far fa-arrow-up-right-from-square fa-xs" />
        </a>
      </th>
      <td>
        <a href={`${client.host}`} target="_blank" rel="noreferrer">
          {client.domain}
          <i className="far fa-arrow-up-right-from-square fa-xs" />
        </a>
      </td>
    </tr>
  );
};

AdminPanelOnlineUserListItem.propTypes = {
  user: PropTypes.object.isRequired,
};

export default AdminPanelOnlineUserListItem;
